import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { useGroupTeachingMaterialsQuery } from "@/api/queries/groups/useGroupTeachingMaterialsQuery"
import { EmptyState } from "toptaal-shared"

export const Route = createFileRoute("/beheer/groepen/$groupId/lesmaterialen/")(
  {
    component: RouteComponent,
    beforeLoad: () => checkPermissions("read", "groups"),
  },
)

function RouteComponent() {
  const { groupId } = useParams({
    from: "/beheer/groepen/$groupId/lesmaterialen/",
  })

  const { data: materials } = useGroupTeachingMaterialsQuery({
    groupId: Number(groupId),
  })

  const materialKeys = Object.keys(materials || {})

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Lesmateriaal</h2>

      {materialKeys?.length === 0 && (
        <EmptyState>Geen lesmaterialen gevonden voor deze groep.</EmptyState>
      )}

      {materialKeys.map((key) => {
        const moduleCode = materials[key].moduleCode
        const teachingMaterials = materials[key].teachingMaterials
        const toptaalTeachingMaterials = materials[key].toptaalTeachingMaterials

        const allMaterials = [
          ...(teachingMaterials ?? []),
          ...(toptaalTeachingMaterials ?? []),
        ]

        return (
          <div key={key} className="mb-8">
            <h3 className="font-bold mb-2 !font-mullish">
              Module {moduleCode}
            </h3>
            <div className="space-y-3">
              {allMaterials.map((material) => (
                <div
                  key={material.id}
                  className="border border-border border-light-grey rounded p-4 flex justify-between items-start "
                >
                  <div className="flex flex-col">
                    <span className="mb-2 font-bold">Titel</span>
                    <span className="">{material.title}</span>
                  </div>
                  <div className="flex flex-col items-end">
                    <span className="mb-2 font-bold">Prijs</span>
                    <span>€{material.price}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}
